import {useRef, useState} from 'react';
import {Queue} from '../controllers/Queue';
import {Song} from '../types';
import {QueueContextProviderValue} from '../context/QueueProvider';
import {mockSongs} from '../components/Pages/Library/mockData';

function useQueue(): QueueContextProviderValue {
  const storedQueue = localStorage.getItem('queue');
  const storedUpNext = localStorage.getItem('upNext');

  const {current: mainQueue} = useRef(
    new Queue(storedQueue ? JSON.parse(storedQueue) : mockSongs),
  );
  const {current: upNextQueue} = useRef(
    new Queue(storedUpNext ? JSON.parse(storedUpNext) : []),
  );
  const [queue, _setQueue] = useState<Song[]>(mainQueue.queue);
  const [upNext, _setUpNext] = useState<Song[]>(upNextQueue.queue);
  const [loading, setLoading] = useState(false);

  const setQueue = (songs: Song[]) => {
    localStorage.setItem('queue', JSON.stringify(songs));
    _setQueue(songs);
  };

  const setUpNext = (songs: Song[]) => {
    localStorage.setItem('upNext', JSON.stringify(songs));
    _setUpNext(songs);
  };

  const handleClear = () => {
    mainQueue.clearQueue();
    setQueue(mainQueue.queue);
  };

  const handlePlayNext = (song: Song) => {
    mainQueue.setQueue([song, ...mainQueue.queue]);
    setQueue(mainQueue.queue);
  };

  const handlePlayLater = (song: Song) => {
    mainQueue.setQueue([...mainQueue.queue, song]);
    setQueue(mainQueue.queue);
  };

  const handlePlayAllNext = (songs: Song[]) => {
    mainQueue.setQueue([...songs, ...mainQueue.queue]);
    setQueue(mainQueue.queue);
  };

  const handlePlayAllLater = (songs: Song[]) => {
    mainQueue.setQueue([...mainQueue.queue, ...songs]);
    setQueue(mainQueue.queue);
  };

  const handleSet = (songs: Song[]) => {
    mainQueue.setQueue(songs);
    setQueue(mainQueue.queue);
  };

  const handleSetUpNext = (songs: Song[]) => {
    upNextQueue.setQueue(songs);
    setUpNext(upNextQueue.queue);
  };

  // TODO: Buggy when duplicate songs in queue, need a unique  identifier
  // for each song added to queue, even if the songs are the same
  const handleRemove = (id: Song['id']) => {
    mainQueue.removeFromQueue(id);
    setQueue(mainQueue.queue);
  };

  // TODO: Buggy when duplicate songs in queue, need a unique  identifier
  // for each song added to queue, even if the songs are the same
  const handleRemoveFromUpNext = (id: Song['id']) => {
    upNextQueue.removeFromQueue(id);
    setUpNext(upNextQueue.queue);
  };

  const handleRefresh = () => {
    setQueue(mainQueue.queue);
    setUpNext(upNextQueue.queue);
  };

  const controller = {
    queue: mainQueue,
    upNextQueue: upNextQueue,
    upNextSongs: upNext,
    songs: queue,
    clear: handleClear,
    playNext: handlePlayNext,
    playAllNext: handlePlayAllNext,
    playLater: handlePlayLater,
    playAllLater: handlePlayAllLater,
    set: handleSet,
    setUpNext: handleSetUpNext,
    remove: handleRemove,
    removeFromUpNext: handleRemoveFromUpNext,
    refresh: handleRefresh,
    loading,
    setLoading,
  };

  return controller;
}

export default useQueue;
